import React from "react";
import { Tabs, Tab, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Typography from "@material-ui/core/Typography";
import { CardBody } from "reactstrap";
import { DocumentarySeries } from "./DocumentarySeries";
import { DocumentarySubseries } from "./DocumentarySubseries";
import { DocumentaryTypes } from "./DocumentaryTypes";
import { ProductionOffice } from "./ProductionOffice";

const CUSTOM_BLUE = "#00BCD4"; 
const CUSTOM_WIDTH = "25%"; // Ancho fijo para cada pestaña

// Función auxiliar para el panel de la pestaña
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

// Función auxiliar para las props de accesibilidad de la pestaña
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  tab: {
    textTransform: "none", 
    minWidth: CUSTOM_WIDTH, 
  },
  indicator: {
    backgroundColor: CUSTOM_BLUE,
  },
}));

export function DocumentRetention() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <CardBody>
      <AppBar position="static" color="transparent" elevation={0}>
        {" "}
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="navegación por secciones"
          classes={{
            indicator: classes.indicator,
          }}
        >
          <Tab
            className={classes.tab}
            label="Dependencias/ Oficinas Productoras"
            {...a11yProps(3)}
          />
          <Tab className={classes.tab} label="Series" {...a11yProps(0)} />
          <Tab className={classes.tab} label="Subseries" {...a11yProps(1)} />
          <Tab
            className={classes.tab}
            label="Tipos Documentales"
            {...a11yProps(2)}
          />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <ProductionOffice />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <DocumentarySeries />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <DocumentarySubseries />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <DocumentaryTypes />
      </TabPanel>
    </CardBody>
  );
}
